/*! js-cookie v3.0.5 | MIT */
function u(e) {
  for (var c = 1; c < arguments.length; c++) {
    var o = arguments[c];
    for (var i in o)
      e[i] = o[i];
  }
  return e;
}
var h = {
  read: function(e) {
    return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(e) {
    return encodeURIComponent(e).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function p(e, c) {
  function o(n, r, t) {
    if (!(typeof document > "u")) {
      t = u({}, c, t), typeof t.expires == "number" && (t.expires = new Date(Date.now() + t.expires * 864e5)), t.expires && (t.expires = t.expires.toUTCString()), n = encodeURIComponent(n).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var s = "";
      for (var d in t)
        t[d] && (s += "; " + d, t[d] !== !0 && (s += "=" + t[d].split(";")[0]));
      return document.cookie = n + "=" + e.write(r, n) + s;
    }
  }
  function i(n) {
    if (!(typeof document > "u" || arguments.length && !n)) {
      for (var r = document.cookie ? document.cookie.split("; ") : [], t = {}, s = 0; s < r.length; s++) {
        var d = r[s].split("="), m = d.slice(1).join("=");
        try {
          var l = decodeURIComponent(d[0]);
          if (t[l] = e.read(m, l), n === l)
            break;
        } catch {
        }
      }
      return n ? t[n] : t;
    }
  }
  return Object.create(
    {
      set: o,
      get: i,
      remove: function(n, r) {
        o(
          n,
          "",
          u({}, r, {
            expires: -1
          })
        );
      },
      withAttributes: function(n) {
        return p(this.converter, u({}, this.attributes, n));
      },
      withConverter: function(n) {
        return p(u({}, this.converter, n), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(c) },
      converter: { value: Object.freeze(e) }
    }
  );
}
var f = p(h, { path: "/" });
let a = f;
const g = {
  init: (e) => (a = f.withAttributes(e || {}), g),
  hasMadeChoice: () => !!a.get("cookies-functional") || !!a.get("cookies-analytics"),
  hasConsent: () => a.get("cookies-analytics") === "true",
  approve: () => {
    a.set("cookies-functional", !0), a.set("cookies-analytics", !0);
  },
  decline: () => {
    a.set("cookies-functional", !0), a.set("cookies-analytics", !1);
  }
}, k = (e = window.location.hostname, c = /\w*\.*?(com|co.uk|net)$/gi) => {
  if (e.includes("localhost")) return "localhost";
  if (e.includes("onrender.com")) return e;
  const o = e.match(c);
  let i = "";
  return o ? i = o[0] : i = e, `.${i}`;
}, v = (e, c, o, i, n = {}) => {
  const r = document.createElement("button");
  r.innerText = c, r.classList.add("vs-cc-bar__button", o), r.addEventListener("click", i);
  for (const [t, s] of Object.entries(n))
    r.setAttribute(t, `${s}`);
  return e == null || e.appendChild(r), r;
}, b = `
<div id="vs-cc" class="vs-cc-bar">
  <div class="vs-cc-bar__container">
    <div class="vs-cc-bar__notification container" role="alert">
      <div class="vs-cc-bar__text">
        <h2 class="vs-cc-bar__title" tabindex="1">🍪 Can we use optional cookies?</h2>
        <p class="no-margin" tabindex="2">
          These cookies help us keep our website safe and give you a better
          experience. We won’t turn them on unless you accept. Want to know more
          or adjust your preferences? Here’s our
          <a id="vs-cc-bar__policy-link">cookie policy</a>.
        </p>
      </div>
      <div class="vs-cc-bar__actions">
        <div class="vs-cc-bar__buttons"></div>
      </div>
    </div>
  </div>
</div>
`, x = (e, c, o, i = b) => {
  const n = document.createElement("div");
  n.id = "vs-cc-wrapper", n.innerHTML = i;
  const r = n.querySelector(".vs-cc-bar__buttons");
  v(
    r,
    "Accept",
    "vs-cc-bar__button--primary",
    c,
    { tabindex: 4 }
  ), v(
    r,
    "Decline",
    "vs-cc-bar__button--secondary",
    o,
    { tabindex: 5 }
  ), document.body.appendChild(n);
  const t = document.querySelector("#vs-cc-bar__policy-link");
  t == null || t.setAttribute("href", e), t == null || t.setAttribute("tabindex", "3");
}, C = () => {
  var e;
  (e = document.querySelector("#vs-cc")) == null || e.classList.add("hiding"), setTimeout(() => {
    var c;
    (c = document.querySelector("#vs-cc-wrapper")) == null || c.remove();
  }, 2e3);
}, j = (e) => {
  w(e), y(e);
}, w = (e) => {
  if (document.querySelector("#vs-cc-script")) return;
  const c = document.createElement("script");
  c.id = "vs-cc-script", c.innerHTML = `
  (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','${e}');
  `, document.head.appendChild(c);
}, y = (e) => {
  if (document.querySelector("#vs-cc-noscript")) return;
  const c = document.createElement("noscript");
  c.id = "vs-cc-noscript";
  const o = document.createElement("iframe");
  o.src = `https://www.googletagmanager.com/ns.html?id=${e}`, o.width = "0", o.height = "0", o.setAttribute("style", "display:none;visibility:hidden"), c.appendChild(o), document.body.insertBefore(c, document.body.firstChild);
};
export {
  x as addBar,
  j as addGaScripts,
  g as cookieTools,
  k as getBaseDomain,
  C as hideBar
};
